import { RegionCode } from '@kaa/api/customers';
import { Environments } from '@kaa/common/enums';
import { getQueryParam } from '@kaa/common/utils';
import get from 'lodash.get';
import { getConfig } from '../../../common/config';
import { getPath, Routes } from '../../routes';

export const REGISTER_PREVIEW_PARAM = 'mbpRedirect';
export const REGISTER_PREVIEW_VALUE = '1';

export const getRedirectUrlToInitiateEid = (state: string): string => {
  const kaaConfig = getConfig();

  const idpBaseUrl = get(kaaConfig, 'app.auth.oidc.authority');
  const returnUrl = window.location.origin + getPath(Routes.REGISTER_COMPLETE);
  return `${idpBaseUrl}/eid/initiate?returnUrl=${returnUrl}&state=${state}`;
};

export const isLegacyRegistrationLocked = (
  regionCode: RegionCode,
): boolean => {
  if (regionCode !== RegionCode.BE_VLG) {
    return false;
  }

  const environment = get(getConfig(), 'app.environment') as Environments;

  if (environment === Environments.PROD) {
    return true;
  }

  return getQueryParam(REGISTER_PREVIEW_PARAM) === REGISTER_PREVIEW_VALUE;
};

export const getLegacyRegistrationLockRedirect = (
  regionCode: RegionCode,
): string | null => {
  if (!isLegacyRegistrationLocked(regionCode)) {
    return null;
  }

  const hasPreviewParam =
    getQueryParam(REGISTER_PREVIEW_PARAM) === REGISTER_PREVIEW_VALUE;

  return getPath(Routes.REGISTER, {
    queryParams: hasPreviewParam
      ? { [REGISTER_PREVIEW_PARAM]: REGISTER_PREVIEW_VALUE }
      : undefined,
  });
};
